import React, { useEffect } from 'react';
import { IColorScheme } from '../types';
import { sendDataToIframe } from '../utils';
import { useEventListner } from '..';

export interface Props {
  roomUrl: string;
  projectId: string;
  theme?: IColorScheme;
}

const HuddleIframe: React.FC<
  React.DetailedHTMLProps<
    React.IframeHTMLAttributes<HTMLIFrameElement>,
    HTMLIFrameElement
  > &
    Props
> = ({ roomUrl, projectId, theme, ...rest }) => {
  useEventListner(
    'app:initialized',
    () => {
      if (theme) {
        sendDataToIframe({
          method: 'theme',
          type: 'huddle01-iframe-from-parent',
          eventData: theme,
        });
        sendDataToIframe({
          method: 'initialize',
          type: 'huddle01-iframe-from-parent',
          eventData: { projectId },
        });
      }
    },
    [theme],
  );

  useEffect(() => {
    if (theme) {
      sendDataToIframe({
        method: 'theme',
        type: 'huddle01-iframe-from-parent',
        eventData: theme,
      });
    }
  }, [theme]);

  return (
    <iframe
      id="huddle01-iframe"
      src={roomUrl}
      name="huddle01"
      allowFullScreen
      allow="camera; microphone; clipboard-read; clipboard-write; display-capture"
      {...rest}
    />
  );
};

export default HuddleIframe;
